import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { ROUTE_PATH } from '@/constants/routes';
import { useAuth } from '@/hooks/useAuth';
import { useDialog } from '@/hooks/useDialog';

interface StaffHeaderProps {
  showLogout?: boolean;
}

export const StaffHeader = ({ showLogout = true }: StaffHeaderProps) => {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { dialogRef, open, close } = useDialog();

  const handleLogoutClick = () => {
    open();
  };

  const handleLogoutConfirm = () => {
    close();
    logout();
    navigate(ROUTE_PATH.STAFF_LOGIN);
  };

  return (
    <>
      <header className="header" data-js="staff-header">
        <div className="header__line">
          <div className="header__inner">
            <div className="header__logo">
              <Link className="header__logo-link" to={ROUTE_PATH.STAFF_LOGIN}>
                <img
                  className="header__logo-img"
                  src="/E_ANA_Logo.png"
                  alt={t('common.altText.anaLogo')}
                />
              </Link>
            </div>
            <div className="header__actions">
              {showLogout && (
                <div className="header__action">
                  <button
                    className="header__button header__button--logout"
                    type="button"
                    onClick={handleLogoutClick}
                  >
                    {t('staffHeader.logout')}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* ログアウト確認ダイアログ */}
      <dialog className="dialog dialog--logout" ref={dialogRef}>
        <div className="dialog__scroll">
          <div className="dialog__line">
            <div className="dialog__area">
              <div className="dialog__text">
                <p className="dialog__text-line">
                  {t('staffHeader.logoutConfirm')}
                </p>
              </div>
              <div className="dialog__actions">
                <button
                  className="dialog__btn dialog__btn--logout"
                  type="button"
                  onClick={handleLogoutConfirm}
                >
                  {t('common.yes')}
                </button>
                <button
                  className="dialog__btn dialog__btn--no"
                  type="button"
                  onClick={close}
                >
                  {t('common.no')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </dialog>
    </>
  );
};
